import { render, staticRenderFns } from "./MinutesToHours.vue?vue&type=template&id=5f19bdbb"
import script from "./MinutesToHours.vue?vue&type=script&lang=js"
export * from "./MinutesToHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports